<div class="flex flex-col pb-4 gap-4">
  <section
    class="bg-gradient-to-tr from-primary rounded-md to-primary/60 text-white p-4 lg:p-6"
  >
    <div class="font-black text-lg md:text-xl">
      {{ _auth?.Student.FirstName }} {{ _auth?.Student.Surname }}
    </div>

    <div
      class="flex flex-col gap-8 justify-between md:flex-row md:gap-4 md:items-end"
    >
      <div class="pt-4">
        <div class="font-bold text-sm pb-1">{{ _auth?.ProgrammeName }}</div>
        <div class="text-xs">{{ _auth?.Department }}</div>
      </div>

      <div class="flex gap-4 flex-wrap">
        <div *ngFor="let item of items" class="text-center">
          <div class="font-bold text-sm pb-1 capitalize">{{ item.title }}</div>
          <div class="text-sm">{{ item.value }}</div>
        </div>

        <div
          *ngIf="showWallet"
          class="text-center cursor-pointer hover:opacity-75 transition select-none"
          (click)="openWalletPopup()"
          title="Click to view wallet details"
        >
          <div class="font-bold text-sm pb-1">Wallet</div>
          <div class="text-sm underline decoration-dotted underline-offset-2">
            &#8358;{{ walletBalance | number:'1.2-2' }}
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    *ngIf="_auth.NewMatricNumber"
    class="border-success rounded flex bg-success/10 border-l-4 text-success p-3 items-center justify-between"
    role="alert"
  >
    <p class="max-w-screen-md text-sm">
      Your new Matriculation number is:
      <strong>{{ _auth.NewMatricNumber }}</strong>
    </p>

    <button
      title="Close"
      (click)="clearMessage()"
      class="rounded p-1 px-2 hover:bg-success/20"
    >
      &times;
    </button>
  </section>
</div>

<!-- Wallet Details Popup -->
<div
  *ngIf="walletPopupVisible"
  role="dialog"
  aria-modal="true"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-500 bg-opacity-75"
  (click)="closeWalletPopup()"
>
  <div
    class="bg-white rounded-xl shadow-xl w-full max-w-sm overflow-hidden"
    (click)="$event.stopPropagation()"
  >
    <!-- Gradient header matching the info bar -->
    <div class="bg-gradient-to-tr from-primary to-primary/60 text-white px-5 py-4">
      <div class="flex justify-between items-start">
        <div>
          <p class="text-xs font-medium text-white/70 uppercase tracking-wide mb-1">Total Balance</p>
          <p class="text-2xl font-bold">&#8358;{{ walletBalance | number:'1.2-2' }}</p>
        </div>
        <button
          (click)="closeWalletPopup()"
          class="text-white/60 hover:text-white text-2xl leading-none mt-0.5"
        >&times;</button>
      </div>
    </div>

    <!-- Buckets -->
    <div class="p-4 space-y-2">
      <p *ngIf="walletBuckets.length === 0" class="text-sm text-gray-400 italic text-center py-2">No balance yet.</p>
      <div *ngFor="let bucket of walletBuckets" class="bg-gray-50 rounded-lg p-3">
        <div class="flex justify-between items-start">
          <div class="min-w-0 flex-1">
            <p *ngIf="!bucket.CollectionTypeHeader" class="font-medium text-sm text-gray-800">
              {{ bucket.CollectionTypeName }}
            </p>
            <p *ngIf="bucket.CollectionTypeHeader" class="font-medium text-sm text-gray-800">
              {{ bucket.CollectionTypeHeader }}
            </p>
            <!-- <p *ngIf="bucket.CollectionTypeHeader" class="text-xs font-medium text-gray-400 mt-0.5 uppercase tracking-wide">
              {{ bucket.CollectionTypeHeader }}
            </p> -->
            <p *ngIf="bucket.SettlesCollectionTypeNames?.length > 0" class="text-xs text-gray-500 mt-1 leading-relaxed">
              {{ bucket.SettlesCollectionTypeNames.slice(0, 4).join(', ') }}{{ bucket.SettlesCollectionTypeNames.length > 4 ? ', etc.' : '' }}
            </p>
          </div>
          <p class="font-semibold text-sm text-gray-700 ml-4 shrink-0">
            &#8358;{{ bucket.Balance | number:'1.2-2' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-4 pb-4 flex justify-end">
      <app-button-primary routerLink="/payments/fund-wallet" (click)="closeWalletPopup()">
        Fund Wallet
      </app-button-primary>
    </div>
  </div>
</div>
